import { Constants } from '../../util/Constants';
export default function TemplateLogo({ children }) {
  const webimage = children?.field_template_logo?.webimage;

  if (!webimage) {
    return null;
  }

  return (
    <div className={'template-logo'}>
      <img alt="template-logo" src={Constants.cloudinaryImage + webimage} />
    </div>
  );
}
